import { autoinject } from 'aurelia-framework';

@autoinject
export class NullDevice {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}